import { TableRow, TableCell } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'

const TestRunAssertion = ({ testRun }) => {
  const stepIndex = (testRun?.steps?.length || 0) + 1
    const resultElements = testRun.result_elements || []

  const renderLabel = () => {
    if (testRun?.is_positive) {
      return `Expected result:`;
    }

    if (testRun?.common_result === 'SUCCESS') {
      return `Assert the error message:`
    }

    const hasText = resultElements[0]?.text;
    return `Assert the error message${hasText ? ':' : ''}`
  }

  const renderResults = () => {
    // if (resultElements.length > 0) {
    //   return (
    //     <ul style={{ paddingLeft: '16px', margin: 0 }}>
    //       {resultElements.map((el, idx) => (
    //         <li key={idx}>&quot;{el.text}&quot;</li>
    //       ))}
    //     </ul>
    //   )
    // }

    // if (testRun?.is_positive) {
    //   return testRun?.common_result;
    // }

    return testRun?.description
  }

  return (
    <TableRow
      className='testRunResultsTableBodyRow'
      sx={{
        backgroundColor:
          testRun?.common_result === 'SUCCESS'
            ? 'rgba(25, 135, 84, 0.1)'
            : testRun?.common_result === 'FAILED'
            ? 'rgba(211, 47, 47, 0.1)'
            : 'inherit',
        cursor: 'default !important'
      }}
    >
      <TableCell className='testRunResultsTableBodyCell stepIndexCell'>
        {stepIndex}
      </TableCell>
      <TableCell className='testRunResultsTableBodyCell stepNameCell'>
        <strong>{renderLabel()}</strong>
      </TableCell>
      <TableCell className='testRunResultsTableBodyCell stepDataCell'>
        {renderResults()}
      </TableCell>
      <TableCell className='testRunResultsTableBodyCell stepResultCell'>
        {testRun.common_result === 'SUCCESS' ? (
          <CheckCircleIcon color="success" />
        ) : (
          <CancelIcon color="error" />
        )}
      </TableCell>
    </TableRow>
  )
}

export default TestRunAssertion